import { existingEquipmentVulcan, tsb15SectionPriceKeys } from '../../../utils/constant';
import { shouldMergeTsb15PriceKeys } from '../secureBusiness/secureBusiness';
import { getFieldSummaryDetailsFromField } from './getFieldSummaryDetails';
import removePriceSubstring from './removePriceSubstring';

/**
 * Builds summary rows and section totals for equipment-based summary rows (e.g. TSB 1.5 Add-on
 * Takeover Equipment or Existing Equipment). Only runs when shouldMergeTsb15PriceKeys is true.
 * Uses row config: sectionKeys, optional filterByDropdownValue and chargeTypeToMatch.
 * Pushes one row per matching field with qty > 0 and mutates total via updateTotal.
 *
 * @param {Object} formFields - Form state
 * @param {Object} row - Summary config row with label and either tsb15TakeoverCharges (charge type) or sectionKeys + optional filterByDropdownValue
 * @param {Object} total - Section total object to update
 * @param {Object} orderData - Order/profile data for eligibility
 * @param {*} valueForCheck - Optional value for eligibility (e.g. yes)
 * @returns {{ label: string, rows: Array }}
 */
export const getTsb15TakeoverChargesSummaryRow = (
  formFields,
  row,
  total,
  orderData,
  valueForCheck
) => {
  if (!shouldMergeTsb15PriceKeys(formFields, orderData, valueForCheck)) {
    return { label: row.label, rows: [] };
  }

  const rows = [];
  const updateTotal = total;

  const sections = row.sectionKeys ;
  const filterByDropdownValue = row.tsb15TakeoverCharges !== 'existingEquipment';
  const chargeTypeToMatch = row.tsb15TakeoverCharges;

  sections.forEach(sectionKey => {
    const section = formFields[sectionKey];
    if (!section) return;
    Object.keys(section).forEach(fieldKey => {
      const baseFieldName = fieldKey.replace('_dropdown', '');
      const isDropdownKey = fieldKey.includes('_dropdown');
      if (filterByDropdownValue) {
        if (!isDropdownKey) return;
      } else if (isDropdownKey) return;
      const field = section[baseFieldName];
      if (!field) return;
      if (filterByDropdownValue && (!field.dropdownValue || field.dropdownValue !== chargeTypeToMatch)) return;
      const rowDetails = getFieldSummaryDetailsFromField(field);
      if (+rowDetails.qty) {
        rows.push({
          ...rowDetails,
          qty: +rowDetails.qty,
          description: removePriceSubstring((field.fieldLabel || '')),
          monthlyCharges:
            rowDetails.monthlyCharges ||
            rowDetails.threeYearEasyPaymentCharges ||
            rowDetails.fiveYearEasyPaymentCharges
        });
        updateTotal.monthlyCharges +=
          (rowDetails.monthlyCharges || 0) +
          (rowDetails.threeYearEasyPaymentCharges || 0) +
          (rowDetails.fiveYearEasyPaymentCharges || 0);
        updateTotal.oneTimeCharges += rowDetails.oneTimeCharges || 0;
        updateTotal.threeYearEasyPaymentCharges +=
          rowDetails.threeYearEasyPaymentCharges || 0;
        updateTotal.fiveYearEasyPaymentCharges +=
          rowDetails.fiveYearEasyPaymentCharges || 0;
      }
    });
  });

  return { label: row.label, rows };
};
